import { useHistoricoDaVenda } from "@/hooks/use-mercado";

/**
 * "Histórico" da venda — o que MUDOU depois de formalizada, com quem e quando
 * (25/09): "Sávio mudou o vencimento de 24/09 para 09/10 na conferência ·
 * 24/09 16:31". A linha do tempo de cima conta as etapas; isto, as mudanças.
 *
 * Frases prontas do servidor — a tela não traduz código de evento. Sem mudança
 * nenhuma, a seção não existe: "nada mudou" não precisa de um card.
 */
export function HistoricoDaVenda({ compartilhamentoId }: { compartilhamentoId: string }) {
  const { data, isError } = useHistoricoDaVenda(compartilhamentoId);
  if (isError) {
    return (
      <section className="rounded-lg border p-4 text-sm text-destructive" role="alert" data-testid="historico-venda-erro">
        Não consegui carregar o histórico da venda. Recarregue a página.
      </section>
    );
  }
  if (!data || data.length === 0) return null;
  return (
    <section className="rounded-lg border bg-card shadow-xs" data-testid="historico-venda">
      <header className="px-4 py-2.5 border-b"><h3 className="font-semibold text-sm">Histórico</h3></header>
      <ul className="p-4 space-y-2 text-[13px]">
        {data.map((e, i) => (
          <li key={`${e.tipo}-${e.em}-${i}`} className="flex flex-col gap-0.5 md:flex-row md:items-baseline md:justify-between md:gap-3">
            <span className="min-w-0">{e.texto}</span>
            <span className="shrink-0 text-xs text-muted-foreground tabular-nums">{fmtDataHora(e.em)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

/** "24/09 16:31" no fuso de quem olha — o mesmo formato do painel do comprador. */
function fmtDataHora(iso: string): string {
  const d = new Date(iso);
  return `${d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })} ${d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}`;
}
